<div class="container">
    <mat-toolbar class="mat-accent m-0 dialog-header">
        <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <button mat-icon-button class="full-screen-dialog-actions" (click)="onCancel()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
            <span class="title dialog-title" fxHide.lt-sm>{{'popups.Impression planning' | transloco}}</span>

            <div class="full-screen-dialog-actions">
                <button mat-raised-button (click)="onYesClick()"> {{'popups.Imprimer' | transloco}}</button>
            </div>


        </mat-toolbar-row>
    </mat-toolbar>
    
    <div class="dialog-content-wrapper">
        <h3 class="title dialog-title mb-28 mt-0" fxHide.gt-xs style="font-size: 20px; font-weight: 500;">{{'popups.Impression planning' | transloco}}</h3>
        <div fxLayout="column">
            <div fxLayout="row space-between" fxLayoutGap="10px" class="picker">
                <mat-form-field appearance="outline" class="flex">
                    <mat-label>{{'popups.debut' | transloco}}</mat-label>
                    <input matInput [matDatepicker]="begin" [(ngModel)]="period.begin" />
                    <mat-datepicker-toggle matSuffix [for]="begin"></mat-datepicker-toggle>
                    <mat-datepicker #begin></mat-datepicker>
                </mat-form-field>
                <mat-form-field appearance="outline" class="flex">
                    <mat-label>{{'popups.fin' |transloco}}</mat-label>
                    <input matInput [matDatepicker]="end" [(ngModel)]="period.end" />
                    <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
                    <mat-datepicker #end></mat-datepicker>
                </mat-form-field>
            </div>
            <mat-form-field appearance="outline">
                <mat-label>{{'popups.Type' |transloco}}</mat-label>
                <mat-select [(ngModel)]="type.selected" multiple>
                    <ng-container *ngFor="let item of type.types">
                        <mat-option class="oneone" [value]="item.value">{{ 'popups.' + item.name| transloco }}</mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>{{'popups.moniteur' | transloco}}</mat-label>
                <mat-select [(ngModel)]="moniteur.selected">
                    <ng-container *ngFor="let item of moniteur.moniteurs">
                        <mat-option class="oneone" [value]="item">{{item.username  }}</mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>{{'popups.candidat' | transloco}}</mat-label>
                <mat-select [(ngModel)]="candidat.selected">
                    <ng-container *ngFor="let item of candidat.candidats">
                        <mat-option class="oneone" [value]="item">{{ item.nom }} {{ item.prenom }}</mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>
        </div>
    </div>
    <div class="basic-dialog-actions" fxLayout="row" fxLayoutAlign="end center">
        <button mat-button (click)="onCancel()">{{'popups.Annuler' | transloco}}</button>
        <button mat-raised-button color="primary" class="mat-accent" (click)="onYesClick()"> {{'popups.Imprimer' | transloco}}
</button>
    </div>

</div>